var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    viewBox: "0 0 510 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__filter0_d_547_1467)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeDasharray: "6 3",
    d: "M4.266 335.156h501.469v41.123H4.266z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeDasharray: "6 3",
    d: "M464.611.723h41.123V376.28h-41.123zM4.266.723h41.148V376.28H4.266z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeDasharray: "6 3",
    d: "M4.266.723h501.469v41.122H4.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.981 46.597v8.754h13.892v4.521H50.981v11.014H45.64V42.117H66.64v4.48H50.981zM88.288 42.117h5.343v28.77h-5.343v-28.77zM123.729 46.638h-9.535v-4.52h24.413v4.52h-9.535v24.248h-5.343V46.638z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.001 58.84l-4.562 4.685v7.357h-5.343v-28.77h5.343v14.755l14.22-14.755h6l-12.083 12.864 12.823 15.906h-6.247l-10.151-12.043zM217.914 71.293c-2.932 0-5.576-.63-7.933-1.891-2.356-1.288-4.205-3.055-5.548-5.302-1.343-2.274-2.014-4.808-2.014-7.603s.671-5.316 2.014-7.562c1.343-2.275 3.192-4.042 5.548-5.302 2.357-1.288 5.001-1.932 7.933-1.932 2.931 0 5.575.644 7.932 1.932 2.356 1.26 4.205 3.014 5.548 5.26 1.343 2.247 2.014 4.782 2.014 7.604s-.671 5.356-2.014 7.603c-1.343 2.247-3.192 4.014-5.548 5.302-2.357 1.26-5.001 1.89-7.932 1.89zm0-4.686c1.917 0 3.644-.424 5.178-1.274a9.556 9.556 0 003.617-3.617c.876-1.561 1.315-3.301 1.315-5.22 0-1.917-.439-3.643-1.315-5.178-.877-1.561-2.083-2.767-3.617-3.616-1.534-.877-3.261-1.316-5.178-1.316-1.918 0-3.645.439-5.179 1.316-1.534.849-2.74 2.055-3.617 3.616-.876 1.535-1.315 3.26-1.315 5.179 0 1.918.439 3.658 1.315 5.22a9.556 9.556 0 003.617 3.616c1.534.85 3.261 1.274 5.179 1.274zM281.115 42.112v28.77h-4.397L260.854 51.4v19.482h-5.302v-28.77h4.397l15.865 19.481v-19.48h5.301zM330.869 42.112v28.77h-4.398L310.607 51.4v19.482h-5.302v-28.77h4.398l15.864 19.481v-19.48h5.302zM376.635 66.402v4.48h-21.577v-28.77h21.002v4.48h-15.659v7.48h13.892v4.398h-13.892v7.932h16.234zM408.977 58.84l-4.562 4.685v7.357h-5.343v-28.77h5.343v14.755l14.22-14.755h6.001l-12.083 12.864 12.823 15.906h-6.248l-10.151-12.043zM449.484 46.633h-9.535v-4.52h24.413v4.52h-9.535v24.248h-5.343V46.633zM369.755 202.971l36.812-41.926H172.446l-21.78-24.742h277.237l36.46-41.928H45.639l208.945 240.532 34.199-39.102-80.316-92.834h161.288z",
    fill: "#E84444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.834 227.275h87.53l-43.046 49.577-44.484-49.577z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#E84444",
    d: "M4.016 334.906h41.623v41.623H4.016zM464.361.473h41.623v41.623h-41.623z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__filter0_d_547_1467",
    x: 0.016,
    y: 0.473,
    width: 509.969,
    height: 384.057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_1467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_547_1467",
    result: "shape"
  })))));
}
export default SvgLogo;